export const ZIP_CODE_LOCAL_STORAGE_KEY = 'zip_code_filter';
